import {
  convertISODateTime,
  convertDefaultTimeZoneStringToISO,
} from "@utils/time-helpers";
import moment from "moment-timezone";

let initialState = {
  addAssetsFilter: {
    queryKeys: ["url", "name"],
    searchValue: "",
    idKey: "url",
  },
  updatedAssetsFilter: {
    queryKeys: ["url"],
    searchValue: "",
    idKey: "url",
  },
  import_source_ctid: "",
  import_base_url: "",
  assetsToAdd: [],
  assetsToUpdate: [],
  assetsToImport: [],
  inputISOScheduledDate: null,
  scheduled_date: null,
  inputISOStopDate: null,
  stop_date: null,
  validInputs: false,
  errors: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "SEARCH_ADD_ASSETS_TABLE_VALUES":
      return {
        ...state,
        addAssetsFilter: {
          ...state.addAssetsFilter,
          searchValue: action.searchValue,
        },
        showResetButton: state.showResetButton || action.searchValue !== "",
      };

    case "SEARCH_UPDATED_ASSETS_TABLE_VALUES":
      return {
        ...state,
        updatedAssetsFilter: {
          ...state.updatedAssetsFilter,
          searchValue: action.searchValue,
        },
        showResetButton: state.showResetButton || action.searchValue !== "",
      };

    case "SET_CTID_ASSETS":
      let { ctidAssets, import_source_ctid, import_base_url } = action || {};
      let assetsToAdd = ctidAssets && ctidAssets.new ? ctidAssets.new : [];
      let assetsToUpdate =
        ctidAssets && ctidAssets.updated ? ctidAssets.updated : [];
      return {
        ...state,
        import_source_ctid: import_source_ctid,
        assetsToAdd: assetsToAdd,
        assetsToUpdate: assetsToUpdate,
        import_base_url: import_base_url || "",
      };

    case "SET_SELECTED_ASSETS":
      return {
        ...state,
        assetsToImport: action.assetsToImport,
      };

    case "SET_IMPORT_DATE": {
      let timeString,
        combinedString,
        newISODateTime = null,
        dateToSet,
        dbDate;
      let setStartDate = action.whatToSet === "startDate";
      if (action.dateString) {
        dateToSet = state.inputISOScheduledDate;
        timeString = dateToSet ? dateToSet : moment.tz("America/New_York").toISOString(); // do not default to 12AM, default to current EST time
        timeString =
          convertISODateTime(
            timeString
          ).toMomentWithConsoleConfigTimeZone.format("h:mmA");
        combinedString = action.dateString + timeString;
        newISODateTime = convertDefaultTimeZoneStringToISO(combinedString);
        dbDate = convertISODateTime(newISODateTime).toDBDateTimeString;
      }

      return {
        ...state,
        ...(setStartDate
          ? { scheduled_date: dbDate, inputISOScheduledDate: newISODateTime }
          : { stop_date: dbDate, inputISOStopDate: newISODateTime }),
      };
    }

    case "SET_IMPORT_TIME": {
      let dateString, combinedString, newISODateTime, dateToSet, dbDate;
      let setStartTime = action.whatToSet === "startTime";
      dateToSet = state.inputISOScheduledDate;
      dateString =
        convertISODateTime(dateToSet).toMomentWithConsoleConfigTimeZone.format(
          "MM/DD/YYYY"
        );
      combinedString = dateString + action.timeString;
      newISODateTime = convertDefaultTimeZoneStringToISO(combinedString);
      dbDate = convertISODateTime(newISODateTime).toDBDateTimeString;
      return {
        ...state,
        ...(setStartTime
          ? { scheduled_date: dbDate, inputISOScheduledDate: newISODateTime }
          : { stop_date: dbDate, inputISOStopDate: newISODateTime }),
      };
    }

    case "RESET_FORM_FIELDS":
      return {
        ...initialState,
      };

    case "SET_IMPORT_ERROR":
      return {
        ...state,
        errors: {
          ...state.errors,
          ...(action.error.errorName
            ? { [action.error.errorName]: action.error.errorPresent }
            : action.error),
        },
      };

    case "ENABLE_POST":
      return {
        ...state,
        validInputs: !action.hasErrors,
      };

    case "SET_SEARCH_FILTER":
      return {
        ...state,
        addAssetsFilter: {
          queryKeys: action.filters,
          searchValue: "",
          idKey: action.idKey,
        },
        updatedAssetsFilter: {
          queryKeys: action.filters,
          searchValue: "",
          idKey: action.idKey,
        },
      };

    default:
      return state;
  }
};
